import { render, staticRenderFns } from "./Efectivos.vue?vue&type=template&id=e1cae2b8"
import script from "./Efectivos.vue?vue&type=script&lang=js"
export * from "./Efectivos.vue?vue&type=script&lang=js"
import style0 from "./Efectivos.vue?vue&type=style&index=0&id=e1cae2b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports